import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class ErrorNotifierInterceptor implements HttpInterceptor {

  constructor(private route: Router) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (request.url.includes('/manageUser/')) {
          if (error.status === 401) {
            this.route.navigate(['user-registration/session-expired']);
            return throwError(() => error);
          }
        }

        return throwError(() => error);
      })
    );
  }
}
